module.exports = __webpack_public_path__ + "img/underground_burnt_fault.682b3a2c.svg";